__turbopack_context__.v({
  "fieldContainer": "ReturnsFields-module-scss-module__HrKgDa__fieldContainer",
  "forgotPassword": "ReturnsFields-module-scss-module__HrKgDa__forgotPassword",
  "tooltipText": "ReturnsFields-module-scss-module__HrKgDa__tooltipText",
});
